<!--
 * @Author: 'lek' '2889356275@qq.com'
 * @Date: 2025-12-16 16:26:00
 * @LastEditors: 'lek' '2889356275@qq.com'
 * @LastEditTime: 2025-12-16 16:26:00
 * @FilePath: \巴斯德\公司网站\bsd_website\src\views\LinksPage.vue
 * @Description: 链接页面 - 简洁设计版本
-->
<template>
  <div class="app">
    <CommonHeader :headerData="headerData" @nav-change="handleNavChange" />

    <!-- 联系信息展示区域 -->
    <section class="email-section">
      <div class="email-container">
        <div class="email-card">
          <!-- 邮箱 - 主要展示 -->
          <div class="email-icon">✉️</div>
          <div class="email-label">{{ $t('links.contact.items.email.title') }}</div>
          <div class="email-address">{{ localizedContactData.email }}</div>
          <div class="email-hint">{{ $t('links.emailHint') }}</div>
          
          <!-- 分隔线 -->
          <div class="divider"></div>
          
          <!-- 地址和电话 - 次要展示 -->
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-icon">地址：</span>
              <span class="contact-text">{{ localizedContactData.address }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon">电话：</span>
              <span class="contact-text">{{ localizedContactData.phone }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <CommonFooter />
    <BackToTop />
  </div>
</template>

<script>
import CommonHeader from '../components/CommonHeader.vue';
import CommonFooter from '../components/CommonFooter.vue';
import BackToTop from '../components/BackToTop.vue';

export default {
  name: 'LinksPage',

  components: {
    CommonHeader,
    CommonFooter,
    BackToTop
  },

  data() {
    return {
      // 头部数据配置
      headerData: {
        logo: {
          title: 'PASTEUR',
          imageUrl: require('@/assets/image/logo.png')
        },
        navigation: [
          { key: 'welcome', active: false, hovered: false },
          { key: 'company', active: false, hovered: false },
          { key: 'products', active: false, hovered: false },
          { key: 'links', active: true, hovered: false }
        ]
      },

      // 邮箱地址
      email: 'contact@bioailego.com'
    }
  },

  computed: {
    // 国际化联系信息
    localizedContactData() {
      return {
        email: this.$t('links.contact.items.email.content'),
        address: this.$t('links.contact.items.address.content'),
        phone: this.$t('links.contact.items.phone.content')
      }
    }
  },

  methods: {
    // 处理导航变化
    handleNavChange(index) {
      const routes = ['/welcome', '/company', '/products', '/links'];
      if (index >= 0 && index < routes.length) {
        const targetRoute = routes[index];
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
}

/* 邮箱展示区域 */
.email-section {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 20px;
  margin-top: 80px;
  background:
    radial-gradient(ellipse at 30% 20%, rgba(0, 212, 180, 0.05) 0%, transparent 50%),
    radial-gradient(ellipse at 70% 80%, rgba(0, 212, 180, 0.03) 0%, transparent 50%),
    linear-gradient(135deg, #fafafa 0%, #f8f9fa 50%, #fafafa 100%);
}

.email-container {
  width: 100%;
  max-width: 600px;
}

/* 分隔线 */
.divider {
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 180, 0.3), transparent);
  margin: 30px auto 20px;
}

/* 联系信息区域 */
.contact-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 0 40px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
  font-size: 13px;
  line-height: 1.5;
}

.contact-text {
  color: #666;
  text-align: left;
}

.contact-icon {
  flex-shrink: 0;
  font-size: 16px;
}

.contact-text {
  color: #555;
}

.email-card {
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  padding: 80px 60px;
  border-radius: 24px;
  box-shadow:
    0 20px 80px rgba(0, 0, 0, 0.08),
    0 8px 30px rgba(0, 212, 180, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  text-align: center;
  border: 1px solid rgba(0, 212, 180, 0.1);
  position: relative;
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.email-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00D4B4 0%, #00B894 100%);
}

.email-card::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(0, 212, 180, 0.03) 0%, transparent 70%);
  pointer-events: none;
}

.email-card:hover {
  transform: translateY(-8px);
  box-shadow:
    0 30px 100px rgba(0, 212, 180, 0.15),
    0 15px 50px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border-color: rgba(0, 212, 180, 0.2);
}

.email-icon {
  font-size: 72px;
  margin-bottom: 30px;
  display: inline-block;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.email-label {
  color: #999;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 20px;
  font-weight: 600;
}

.email-address {
  font-size: 28px;
  color: #0cc6b0;
  font-weight: 700;
  margin-bottom: 25px;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #0cc6b0 0%, #0cc6b0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  word-break: break-all;
  transition: all 0.3s ease;
}

.email-card:hover .email-address {
  transform: scale(1.05);
}

.email-hint {
  color: #999;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .email-section {
    padding: 100px 20px;
    margin-top: 60px;
    min-height: calc(100vh - 60px);
  }

  .email-card {
    padding: 60px 40px;
  }

  .email-icon {
    font-size: 60px;
    margin-bottom: 25px;
  }

  .email-label {
    font-size: 12px;
    letter-spacing: 2px;
  }

  .email-address {
    font-size: 22px;
  }

  .email-hint {
    font-size: 13px;
  }

  .divider {
    margin: 25px auto 15px;
  }

  .contact-item {
    font-size: 13px;
  }

  .contact-info {
    gap: 14px;
  }
}

@media (max-width: 480px) {
  .email-section {
    padding: 80px 15px;
    margin-top: 50px;
    min-height: calc(100vh - 50px);
  }

  .email-card {
    padding: 50px 25px;
  }

  .email-icon {
    font-size: 50px;
    margin-bottom: 20px;
  }

  .email-label {
    font-size: 11px;
    letter-spacing: 1.5px;
  }

  .email-address {
    font-size: 18px;
  }

  .email-hint {
    font-size: 12px;
  }

  .divider {
    margin: 20px auto 15px;
    width: 50px;
  }

  .contact-info {
    gap: 12px;
    padding: 0 10px;
  }

  .contact-item {
    font-size: 12px;
    gap: 8px;
  }

  .contact-icon {
    font-size: 14px;
  }
}
</style>